import React, { useState } from 'react';
import './BusinessContext.scss';
import EditContextDialog from './EditContextDialog';

const BusinessContext = ({ contextItems = [], colorData }) => {
  const [editOpen, setEditOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const handleEditClick = (item) => {
    setEditingItem(item);
    setEditOpen(true);
  };

  const handleSaveContext = async (updatedItem) => {
    // 🔥 API CALL GOES HERE
    // await api.updateBusinessContext(updatedItem.id, updatedItem);

    console.log('Saving context:', updatedItem);

    // Optionally refresh data here
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div
      className="business-context-container mt-5 mb-5 demo-section"
      style={{
        borderBottom: '5px solid rgb(231 221 218)',
        borderTop: '5px solid rgb(231 221 218)',
        paddingBottom: '100px',
        paddingTop: '100px'
      }}
    >
      <h2 className="mb-2 poppin text-center mb-5">
        Services Information
      </h2>

      {/* EDIT DIALOG */}
      <EditContextDialog
        open={editOpen}
        item={editingItem}
        onClose={() => setEditOpen(false)}
        onSave={handleSaveContext}
      />

      {/* CONTEXT ITEMS */}
      <div className="row">
        {contextItems.length === 0 ? (
          <div className="col-12">
            <div className="alert alert-info">
              <i className="fas fa-info-circle me-2"></i>
              No business context items found.
            </div>
          </div>
        ) : (
          contextItems.map((item) => (
            <div key={item.id} className="col-md-6 col-lg-4 mb-4">
              <div className="card h-100 shadow-sm">
                <div className="card-header d-flex justify-content-between align-items-center p-3">
                  <span
                    className="badge poppin p-2 fs-6"
                    style={{ borderBottom: `5px solid ${colorData?.secondary}`,
                     backgroundColor: colorData?.tertiary || '#E8F2FC',
                    color: colorData?.footer_color || 'black'
                  }}


                    
                  >
                    <i className="fas fa-tag me-1"></i>
                    {item.category}
                  </span>

                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handleEditClick(item)}
                  >
                    <i className="fas fa-edit me-1"></i>
                    Edit
                  </button>
                </div>


                <div className="card-body">
                  <p className="card-text poppin">
                    {item.key_info}
                  </p>
                </div>

                <div className="card-footer">
                  <small className="text-muted">
                    <i className="fas fa-clock me-1"></i>
                    Updated: {formatDate(item.last_updated)}
                  </small>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BusinessContext;
